import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=6d0af76c&"
import script from "./BaseSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports